import { createPostGraphqlRequest } from '@tv2/lib-core/request';
import { getLiveSessionManager } from '@tv2-player/unifiedplayer/src/plugins/Yospace/yospaceManager';
import { makeMediaObject } from '../services/media';
import { defaultHeaders } from '../config/headers';
import Endpoints from '../config/endpoints';
import { CustomerType } from '../customerType/__generated__/CustomerType';
import { log, normalizeErrors } from '../handlers/error';

/**
 * Creates a Yospace manager and updates the src with the master playlist from Yospace.
 * @param {object} media Media object from graphQL.
 * @param accessToken
 * @returns {object} Media with updates src.
 */
export async function prepareYospace(
  media: ReturnType<typeof makeMediaObject>,
  accessToken?: string
) {
  try {
    const headers = {
      ...defaultHeaders(),
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : null),
    };

    const data = accessToken
      ? await createPostGraphqlRequest(Endpoints.api, CustomerType, {}, 'CustomerType', headers)
      : null;
    const firstSubscription = data?.customerType?.products?.[0];
    const providerId = firstSubscription?.providerId;
    const productId = firstSubscription?.id;

    let customHeaders;
    if (providerId != null && productId != null) {
      customHeaders = new Map([
        ['segm_params', media.ads?.segmentation?.split('=')?.[1]],
        ['segm_prodid', productId],
        ['segm_partid', providerId],
      ]);
    }
    const manager = await getLiveSessionManager(media, customHeaders);
    if (manager) {
      media.src = manager.getPlaybackUrl();
    }
  } catch (err) {
    normalizeErrors(err).forEach(log);
  }
  return media;
}
